module.exports = __webpack_public_path__ + "static/img/serviceAct4.8fbc2780.png";